// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4a334585","977":"dffa6e0a"}[chunkId] + ".chunk.js";
};